/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mvp_Sprint_Scope_Detail5Inputs */

const en_svc_mvp_sprint_scope_detail5 = /** @type {(inputs: Svc_Mvp_Sprint_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lock scope, timeline and fixed price in one doc.`)
};

const ar_svc_mvp_sprint_scope_detail5 = /** @type {(inputs: Svc_Mvp_Sprint_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ثبت النطاق والجدول والسعر الثابت في مستند واحد.`)
};

const bn_svc_mvp_sprint_scope_detail5 = /** @type {(inputs: Svc_Mvp_Sprint_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এক ডকে স্কোপ, সময়সূচি আর ফিক্সড প্রাইস আটকে দিন।`)
};

const de_svc_mvp_sprint_scope_detail5 = /** @type {(inputs: Svc_Mvp_Sprint_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umfang, Zeitplan und Festpreis in einem Dokument festzurren.`)
};

const es_svc_mvp_sprint_scope_detail5 = /** @type {(inputs: Svc_Mvp_Sprint_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fijar alcance, calendario y precio fijo en un documento.`)
};

const fr_svc_mvp_sprint_scope_detail5 = /** @type {(inputs: Svc_Mvp_Sprint_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verrouillez périmètre, calendrier et prix fixe dans un document.`)
};

const pt_svc_mvp_sprint_scope_detail5 = /** @type {(inputs: Svc_Mvp_Sprint_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fixe âmbito, calendário e preço fixo num documento.`)
};

const zh_svc_mvp_sprint_scope_detail5 = /** @type {(inputs: Svc_Mvp_Sprint_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用一份文档锁死范围、排期和固定价格。`)
};

const tr_svc_mvp_sprint_scope_detail5 = /** @type {(inputs: Svc_Mvp_Sprint_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapsam, takvim ve sabit fiyatı tek belgede kilitle.`)
};

const ru_svc_mvp_sprint_scope_detail5 = /** @type {(inputs: Svc_Mvp_Sprint_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зафиксируйте скоуп, сроки и фикс-прайс в одном документе.`)
};

const pl_svc_mvp_sprint_scope_detail5 = /** @type {(inputs: Svc_Mvp_Sprint_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamroź zakres, harmonogram i stałą cenę w jednym dokumencie.`)
};

/**
* | output |
* | --- |
* | "Lock scope, timeline and fixed price in one doc." |
*
* @param {Svc_Mvp_Sprint_Scope_Detail5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mvp_sprint_scope_detail5 = /** @type {((inputs?: Svc_Mvp_Sprint_Scope_Detail5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mvp_Sprint_Scope_Detail5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mvp_sprint_scope_detail5(inputs)
	if (locale === "bn") return bn_svc_mvp_sprint_scope_detail5(inputs)
	if (locale === "de") return de_svc_mvp_sprint_scope_detail5(inputs)
	if (locale === "es") return es_svc_mvp_sprint_scope_detail5(inputs)
	if (locale === "fr") return fr_svc_mvp_sprint_scope_detail5(inputs)
	if (locale === "pt") return pt_svc_mvp_sprint_scope_detail5(inputs)
	if (locale === "zh") return zh_svc_mvp_sprint_scope_detail5(inputs)
	if (locale === "tr") return tr_svc_mvp_sprint_scope_detail5(inputs)
	if (locale === "ru") return ru_svc_mvp_sprint_scope_detail5(inputs)
	if (locale === "pl") return pl_svc_mvp_sprint_scope_detail5(inputs)
	return en_svc_mvp_sprint_scope_detail5(inputs)
});
export { svc_mvp_sprint_scope_detail5 as "svc_mvp-sprint_SCOPE_detail" }